module.exports = __webpack_public_path__ + "static/img/award1_a.34847b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award1_a.png
// module id = +vBq
// module chunks = 7